import {
  WARNING_BACKGROUND,
  WARNING_COLOR
} from "../../../../../../../themes/themeConfigurator";

const styles = () => ({
  dialogTitle: {
    background: WARNING_BACKGROUND,
    '& .fa-exclamation-circle': {
      color: WARNING_COLOR,
    }
  },
  categoryName: {
    fontFamily: 'Roboto-Bold',
    fontSize: 18,
  },
  categoryItemsCount: {
    color: 'rgba(15, 23, 42, 0.60)',
    fontSize: 12,
  }
});

export default styles;